module.exports = __webpack_public_path__ + "media/חפרה.3a62f8f2.mp3";